import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useBreakpoint } from '~/techstyle-shared/react-components';

import {
  GAP_BETWEEN_GRID_COLUMNS_DESKTOP,
  GAP_BETWEEN_GRID_COLUMNS_MOBILE,
  GAP_BETWEEN_GRID_ROWS,
  GRID_CARD_TYPES,
} from '../constants';
import useNumGridCols from '../hooks/useNumGridCols';
import { getCellHeight } from '../utils/measurements';

import AssetCard from './AssetCard';
import GridIndexInfo from './GridIndexInfo';
import ProductCard from './ProductCard/ProductCard';

const GridIndexInfoWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: ${({ theme }) => theme.colors.palette.white};
  width: 80%;
`;

const StyledAssetCard = styled(AssetCard)`
  width: 100%;
  height: auto;
  border-radius: 12px;
`;

const GridCardRenderer = ({
  item,
  dynamicCardWidth,
  row,
  column,
  showIndexInfo = false, // TODO: make this a FF or debug admin option
}) => {
  const numGridColumns = useNumGridCols();
  const columnSpan = item?.span?.columns || 1;
  const rowSpan = item?.span?.rows || 1;
  const { isMobile } = useBreakpoint();
  const gridIndex = row * numGridColumns + column;

  const cellHeight = getCellHeight({
    isMobile,
    dynamicCardWidth,
  });

  return (
    <div
      style={{
        gridColumn: `span ${columnSpan}`,
        gridRow: `span ${rowSpan}`,
        width:
          dynamicCardWidth * columnSpan +
          (isMobile
            ? GAP_BETWEEN_GRID_COLUMNS_MOBILE
            : GAP_BETWEEN_GRID_COLUMNS_DESKTOP) *
            (columnSpan - 1),
        height: cellHeight * rowSpan + GAP_BETWEEN_GRID_ROWS * (rowSpan - 1),
        position: 'relative',
      }}
    >
      {showIndexInfo && (
        <GridIndexInfoWrapper>
          <GridIndexInfo
            numGridColumns={numGridColumns}
            row={row}
            column={column}
            customVars={item?.options?.customVars}
          />
        </GridIndexInfoWrapper>
      )}
      {item?.type === GRID_CARD_TYPES.ASSET ? (
        <StyledAssetCard {...item} />
      ) : (
        <ProductCard {...item} gridIndex={gridIndex} />
      )}
    </div>
  );
};

GridCardRenderer.propTypes = {
  column: PropTypes.number.isRequired,
  dynamicCardWidth: PropTypes.number.isRequired,
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    type: PropTypes.string.isRequired,
    span: PropTypes.shape({
      rows: PropTypes.number,
      columns: PropTypes.number,
    }),
    options: PropTypes.shape({
      customVars: PropTypes.object,
    }),
  }).isRequired,
  row: PropTypes.number.isRequired,
  showIndexInfo: PropTypes.bool,
};

export default GridCardRenderer;
